/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return*/

import React, { useState, useEffect } from "react";

import {
  Paper,
  TableRow,
  TableBody,
  TableContainer,
  TableCell,
  Table,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  Loading,
  ModalDeleteConfirm,
  TableCellDefault,
  TableHeader,
  Title,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import {
  useDatatables,
  useDatatablesServerSide,
  useHeadTarif,
  useLocalStorageForm,
} from "App/hooks";
import { PencilIcon, TrashIcon } from "App/Assets";
import {
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
  removeLocalStorageAsFormData,
  scrollToTop,
} from "App/utils/helpers";
import {
  FormPaket,
  headCells,
  deletePaketById,
  RESET_STATE_PAKET,
  urlGet,
  getPaketById,
  FieldFormTarif,
} from "./ui";
import { pushJasaTarif } from "../helperMasterPenjualan";
import { getAllTarif } from "../../Tarif/helpers";
import {
  FORM_LOCAL_STORAGE_PAKET_HARGA,
  FORM_LOCAL_STORAGE_PAKET_HARGA_CUSTOM,
  MS_PAKET,
} from "App/constants";
import {
  FormFilterJasa,
  getByFilterJenisHarga,
  RESET_STATE_FORM_FILTER,
} from "../Jasa/ui";

export default function Rikjang() {
  const [formData, setFormData] = useLocalStorageForm(
    RESET_STATE_PAKET,
    MS_PAKET
  );

  const [rows, setRows] = useState([]);
  const { dynamicHead, dataTarif } = useHeadTarif({
    data: headCells,
  });
  const [paketID, setPaketID] = useState("");

  const [fieldTarif, setFieldTarif] = useState([]);

  const [formHargaTarifBeli, setFormHargaTarifBeli] = useState([]);

  const [formHargaTarifJual, setFormHargaTarifJual] = useState([]);

  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);

  useEffect(() => {
    (async () => {
      const res = await getAllTarif();
      setFormValues(res);
    })();
  }, []);

  const setFormValues = (res) => {
    const { dataTarif, dataFormTarifBeli, dataFormTarifJual } =
      pushJasaTarif(res);
    setFieldTarif(dataTarif);

    const formLocal = localStorage.getItem(FORM_LOCAL_STORAGE_PAKET_HARGA);
    if (formLocal) {
      setFormHargaTarifBeli(JSON.parse(formLocal));
    } else {
      setFormHargaTarifBeli(dataFormTarifBeli);
    }

    const formLocal2 = localStorage.getItem(
      FORM_LOCAL_STORAGE_PAKET_HARGA_CUSTOM
    );
    if (formLocal2) {
      setFormHargaTarifJual(JSON.parse(formLocal2));
    } else {
      setFormHargaTarifJual(dataFormTarifJual);
    }
  };

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);
    const res = await getByFilterJenisHarga(formFilter, pages, limit, urlGet);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  useEffect(() => {
    if (!isNull(formFilter.id_jenis_harga)) {
      setNewData();
    }
  }, []);

  const reset = () => {
    setFormHargaTarifBeli([]);
    setFormHargaTarifJual([]);
    setFormData(RESET_STATE_PAKET);
    setPaketID("");
    removeLocalStorageAsFormData(MS_PAKET);
    removeLocalStorageAsFormData(FORM_LOCAL_STORAGE_PAKET_HARGA);
    removeLocalStorageAsFormData(FORM_LOCAL_STORAGE_PAKET_HARGA_CUSTOM);
  };

  return (
    <div>
      <Title title={"Paket"} />

      <FormPaket
        formData={formData}
        setNewData={setNewData}
        setFormData={setFormData}
        fieldTarif={fieldTarif}
        formHargaTarifBeli={formHargaTarifBeli}
        setFormHargaTarifBeli={setFormHargaTarifBeli}
        formHargaTarifJual={formHargaTarifJual}
        setFormHargaTarifJual={setFormHargaTarifJual}
        paketID={paketID}
        dataTarif={dataTarif}
        reset={reset}
      />

      <TablePaketContainer
        formFilter={formFilter}
        setFormFilter={setFormFilter}
        dataTarif={dataTarif}
        dynamicHead={dynamicHead}
        loading={loading}
        setLoading={setLoading}
        paketID={paketID}
        setPaketID={setPaketID}
        setFormHargaTarifBeli={setFormHargaTarifBeli}
        setFormHargaTarifJual={setFormHargaTarifJual}
        totalData={totalData}
        setFormData={setFormData}
        setNewData={setNewData}
        rows={rows}
      />
    </div>
  );
}

export const TablePaketContainer = ({
  formFilter,
  setFormFilter,
  setNewData,
  loading,
  setLoading,
  totalData,
  setPaketID,
  paketID,
  setFormData,
  setFormHargaTarifBeli,
  setFormHargaTarifJual,
  dataTarif,
  dynamicHead,
  rows,
  withAction = true,
}) => {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const classes = STYLE_DEFAULT_MASTER();

  const handleClickUpdate = (row) => {
    setVal(row);
  };

  const handleClickDelete = (row) => {
    setPaketID(row.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  async function deleteList() {
    const res = await deletePaketById(paketID);
    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
      setPaketID("");
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }
  const setVal = async (row) => {
    setLoading(true);
    setPaketID(row.id);
    const res = await getPaketById(row.id, formFilter.id_jenis_harga);
    setFormData({
      id_jenis_paket: row.id_jenis_paket,
      id_tarif_cbg: row.id_tarif_cbg,
      tarif_cbg: isNull(row.namaTarifCbg)
        ? "Pilih Tarif CBG"
        : row.namaTarifCbg,
      nama: row?.nama,
      gudang_id: row.id_gudang,
      gudang_name: row.namaGudang,
      barang: res.data.barang,
      jasa: res.data.jasa,
      fasilitas: res.data.fasilitas,
      id_jenis_harga: formFilter.id_jenis_harga,
      rikjang: res.data.rikjang,
      isUpdate: true,
      harga: row?.harga,
      status: row?.status,
    });

    const valueTarifBeli = [];
    const valueTarifJual = [];

    row?.harga.map((e) => {
      valueTarifBeli.push({
        id: e.id,
        id_tarif: e.id_tarif,
        harga: e.harga,
        harga2: formatNumber(e.harga),
      });

      valueTarifJual.push({
        id: e.id,
        id_tarif: e.id_tarif,
        harga_custom: e.harga_custom,
        harga_custom2: formatNumber(e.harga_custom),
      });
    });

    setFormHargaTarifBeli(valueTarifBeli);
    setFormHargaTarifJual(valueTarifJual);
    scrollToTop();
    setLoading(false);
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <div className="mt-2">
        <Paper className={classes.paper}>
          <div className="p-1">
            <Loading show={loading} />
            <FormFilterJasa
              formFilter={formFilter}
              setFormFilter={setFormFilter}
              title="Daftar Paket"
              setNewData={setNewData}
              type="Paket"
              titleExport="Export List Master Paket"
              url="/master/paket/ms_paket/list-export"
            />

            <TablePaket
              rows={rows}
              classes={classes}
              dynamicHead={dynamicHead}
              dataTarif={dataTarif}
              handleClickDelete={handleClickDelete}
              handleClickUpdate={handleClickUpdate}
              withAction={withAction}
            />

            <DatatablesFooterServerSide
              totalData={totalData}
              pagination={pagination}
              handleChangeLimit={handleChangeLimit}
              onPrevious={onPrevious}
              onNext={onNext}
              currentPage={pagination.page}
              handleClickPageNumber={handleClickPageNumber}
            />
          </div>
        </Paper>
      </div>
    </>
  );
};

const TablePaket = ({
  rows,
  classes,
  dynamicHead,
  dataTarif,
  handleClickDelete,
  handleClickUpdate,
  withAction,
}) => {
  const { order, orderBy, handleRequestSort } = useDatatables({
    rows: rows,
    orderByDefault: "nama",
    orderByRow: ["nama"],
  });

  return (
    <TableContainer className="custom-scrollbar">
      <Table
        className={classes.table}
        aria-labelledby="tableTitle"
        size={"medium"}
        aria-label="enhanced table"
      >
        <TableHeader
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={rows.length}
          headCells={dynamicHead}
        />
        <TableBody>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>

                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {withAction && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                      }}
                    >
                      <IconButtonDatatable
                        onClick={() => handleClickUpdate(row)}
                      >
                        <PencilIcon />
                      </IconButtonDatatable>

                      <IconButtonDatatable
                        onClick={() => handleClickDelete(row)}
                      >
                        <TrashIcon />
                      </IconButtonDatatable>
                    </div>
                  )}
                </TableCell>

                <TableCell align="left">{row?.nama}</TableCell>
                <FieldFormTarif dataTarif={dataTarif} row={row} />
                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align="center" colSpan={dynamicHead.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
